import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function HomeSubcategories() {
  const { panelId, categoryId } = useParams();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    if (!categoryId) return;
    const loadSubcats = async () => {
      try {
        const res = await axiosPrivate.get(`/Subcategories/Public/ByCategory/${categoryId}`);
        if (typeof res.data === "string" && res.data === "No records") {
          setSubcategories([]);
        } else {
          setSubcategories(res.data);
        }
      } catch (err) {
        enqueueSnackbar("Cannot load subcategories", { variant: "error" });
      }
    };
    loadSubcats();
  }, [categoryId, axiosPrivate, enqueueSnackbar]);

  const handleSubcatClick = (subcategoryId) => {
    navigate("/Tools/"+panelId+"/"+categoryId+"/"+subcategoryId);
  };

  return (
    <div className="container px-3 overflow-hidden">
      <div className="row text-center">
        <h1>Welcome to Online-CADCOM (Tools)</h1>
        <p>Online assisted Platform for Computer-aided design in communications</p>
      </div>
      <div className="row justify-content-center">
        {subcategories && (
          subcategories.map((sc) => (
            <div key={sc.id} className="col-12 col-md-4 d-flex justify-content-center mb-2">
              <div className="card text-center" style={{ width: "28rem", minHeight: "10rem" }}>
                <div className="card-body">
                  <h5 className="card-title">{sc.name}</h5>
                  <p className="card-text">{sc.categoryName}</p>
                  <span className="btn btn-primary" onClick={() => handleSubcatClick(sc.id)}>{t("list")+" "+t("tools")}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default HomeSubcategories;
